import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AdminToolbar from '../../Toolbar/AdminToolbar';
import EditorToolbar from '../../Toolbar/EditorToolbar';
import ManageGuides from './ManageGuides';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import GuidePendingRequest from './GuidePendingRequest';
import UserToolbar from '../../../User/UserToolbar';
import ManageGuidesUser from './ManageGuideUser';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ManageGuideWrapper = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState('1');

  useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });
        const { user, username } = res.data;
        if (username && (user === 'Admin' || user === 'Editor' || user === 'User')) {
          setUserType(user);
          setUsername(username);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    getUserFromCookie();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
        setValue(newValue);
    }
};
  return (
    <>
     
      {userType === 'Admin' && (
            <>
            <AdminToolbar/>
        <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Manage Guides" value="1" />
            <Tab label="Manage Requests" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1"> <ManageGuides /></TabPanel>
        <TabPanel value="2"><GuidePendingRequest/></TabPanel>
      </TabContext>
            </>
          )}
      {userType === 'Editor' && (
            <>
            <EditorToolbar/>
            <ManageGuides/>
            </>
          )}
        {userType === 'User' && (
                  <>
                  <UserToolbar/>
                  <ManageGuidesUser/>
                  </>
                )}
    </>
  );
};

export default ManageGuideWrapper;
